export default __webpack_public_path__ + "static/media/Brow_5_C1.d26b046f.svg";